import React, { useState } from 'react';
import Card2 from './card2';
import '../styles/skills.css';
import skillsData from '../utils/skillsData.js';

const Skills = (props,{id}) => {
  const [showMore, setShowMore] = useState(false);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const renderSkills = () => {
    const skillsToRender = showMore ? skillsData : skillsData.slice(0, 8);
    return skillsToRender.map((skill, index) => (
      <Card2
        key={index}
        rootClassName={`rootClassName${index + 1}`}
        title={skill.Name}
        description={skill.Description}
        icon={skill.icon}
      />
    ));
  };

  return (
    <div className="skills-skills" id="skills">
      <h1 className="skills-text">
        <span>My Skills</span>
        <br />
      </h1>
      <span className="skills-text3">
        <span>These are the skills I learned in the past few years.</span>
        <br />
        <br />
      </span>
      <div className={`skills-container ${showMore ? 'show-more' : ''}`}>
        {renderSkills()}
      </div>
      {skillsData.length > 8 && (
        <a onClick={toggleShowMore} className="skill-link">
          {showMore ? 'Show Less' : 'See More'}
        </a>
      )}
    </div>
  );
};

export default Skills;
